import { css } from '@emotion/core';
import MediaQueries from '../../../../styles/Grid/MediaQueries';
import { typography, fontWeights } from '../../../../styles/typography';
import { colorsPalette } from '../../../../styles/colors';

export const headerCss = css({
  marginBottom: 36,
  [MediaQueries.md]: {
    marginBottom: 48,
  },
  [MediaQueries.lgAndUp]: {
    marginBottom: 72,
  },
});

export const headlineCss = css(typography.effra48, {
  color: colorsPalette.black,
  fontWeight: fontWeights.medium,
  hyphens: 'auto',
});

export const bodyDescriptionCss = css(typography.effra18, {
  color: colorsPalette.grey80,
  paddingTop: 24,
});

export const anchorCss = css({
  margin: '28px 0 5px',
  [MediaQueries.lgAndUp]: {
    margin: '12px 0 45px',
  },
});
